import React from "react";
import { FormGroup, Label, Input, Button } from "reactstrap";
import style from "./Toolbar.module.scss";

const Advanced = ({ open, onChange, toggle, ...props }) => {
  if (open == false) {
    return null;
  }

  return (
    <FormGroup className={style.advanced}>
      <Label>Date range</Label>
      <div className={style.inputs}>
        <Input
          type="date"
          value={props.fromDate}
          placeholder="From"
          onChange={(e) => onChange({ dateFrom: e.target.value })}
          required
        />
        <div style={{ width: "15px" }} />
        <Input
          type="date"
          value={props.toDate}
          placeholder="To"
          onChange={(e) => onChange({ dateTo: e.target.value })}
        />
      </div>
      <Button type="button" color="primary" onClick={() => props.onSearch()}>
        Search
      </Button>

      <Button type="button" color="primary" style={{ marginLeft: "5px" }} onClick={() => toggle()}>
        Hide <i className="fa fa-caret-up"></i>
      </Button>
    </FormGroup>
  );
};

export default Advanced;
